import { PermanentJobsApi } from '../clients';

export const postPermValuePropViewed = async (): Promise<void> =>
  PermanentJobsApi.postPermValuePropViewed();
